export default __webpack_public_path__ + "static/media/chip-placeholder.4c595540.png";